export default {
  title: 'INXY Payments account login',
  formTip: 'Don’t have an INXY Payments account yet?',
}
